import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FIND_ALL_ORDERS_PAGINATION,
  GENERATE_PDF,
  GET_ALL_IN_PROGRESS_SERVICE_TASK_ASSIGNMENTS,
  GET_ALL_SALES_ORDERS,
  GET_ALL_WORK_ORDERS,
  GET_ONE_DESIGNATION,
  GET_ONE_SALES_ORDER,
  GET_ONE_WORK_ORDER,
  GET_TASK_TIMELINE_FOR_ORDER,
  ORDER_SERVICES,
  SERVICE_TASK_ASSIGNMENTS,
  SERVICE_TASK_LIST_FOR_EMPLOYEE,
  TASK_TIMELINES,
} from '../graphql/queries/salesOrder.queries';
import {
  CREATE_ACTIVITY,
  MARK_AS_COMPLETED_ORDER,
  MARK_AS_COMPLETED_ORDER_SERVICE,
  MODIFY_TASK_ASSIGNMENT,
  REMOVE_TASK_TIMELINE,
  REMOVE_WORK_ORDER,
  UPDATE_ORDER,
  UPDATE_WORK_ORDER,
} from '../graphql/mutation/salesOrder.mutation';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderService {
  pdfResponse: any;
  constructor(private apollo: Apollo) {}

  getWorkOrderById(id: number): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_ONE_WORK_ORDER,
        variables: {
          id: id,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.workOrder || []));
  }

  findOneByDesignation(designationName: any): Observable<any> {
    return this.apollo
      .use('hrms')
      .watchQuery<any>({
        query: GET_ONE_DESIGNATION,
        variables: {
          designationName
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.findOneByDesignation || []));
  }

  getAllWorkOrders(search?: string): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_ALL_WORK_ORDERS,
        variables: {
          search: search || null,
          projectId: null,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.workOrders || []));
  }

  updateWorkOrder(
    updateWorkOrderInput: any,
    workOrderItems: any,
    fileAttachments: any
  ): Observable<any> {
    return this.apollo
      .use('project')
      .mutate({
        mutation: UPDATE_WORK_ORDER,
        variables: {
          updateWorkOrderInput,
          workOrderItems,
          fileAttachments,
        },
      })
      .pipe(map((result: any) => result.data.updateworkOrder || []));
  }

  getAllWorkOrder(
    search: string,
    projectId?: number,
    startDate?: any,
    endDate?: any
  ): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_ALL_WORK_ORDERS,
        fetchPolicy: 'network-only',
        variables: {
          search,
          projectId,
          startDate,
          endDate,
        },
      })
      .valueChanges.pipe(map((result) => result.data?.workOrders || []));
  }

  removeWorkOrder(id: number): Observable<any> {
    return this.apollo
      .use('project')
      .mutate({
        mutation: REMOVE_WORK_ORDER,
        variables: {
          id: id,
        },
      })
      .pipe(map((result: any) => result.data.removeWorkOrder || []));
  }

  createActivity(createTaskTimelineInput: any): Observable<any> {
    return this.apollo
      .use('project')
      .mutate({
        mutation: CREATE_ACTIVITY,
        variables: {
          createTaskTimelineInput,
        },
      })
      .pipe(map((result: any) => result.data.createTaskTimeline || []));
  }

  generatePdf(id: number, type: boolean): Observable<any> {
    return this.apollo
      .use('project')
      .query<any>({
        query: GENERATE_PDF,
        variables: {
          workOrderId: id,
          withPrice: type,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result) => result.data?.generateWorkOrderPdf || []));
  }

  getAllSalesOrders(search?: string): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_ALL_SALES_ORDERS,
        variables: {
          search: search || null,
          projectId: null,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.orders || []));
  }

  getSalesOrderById(id: number): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_ONE_SALES_ORDER,
        variables: {
          id: id,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.order || []));
  }

  getTaskTimelinesForAnOrder(orderId: number): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_TASK_TIMELINE_FOR_ORDER,
        variables: {
          orderId,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.getTaskTimelinesForAnOrder || []));
  }

  serviceTaskAssignment(id: number): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: SERVICE_TASK_ASSIGNMENTS,
        variables: {
          id: id,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.serviceTaskAssignment || []));
  }

  taskTimelines(search: any, assignmentId: number, actionTypes: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: TASK_TIMELINES,
        variables: {
          search,
          assignmentId,
          actionTypes
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.taskTimelines || []));
  }

  modifyTaskAssignment(id: number, updateServiceTaskAssignmentInput: any, CreateTaskTimelineInput: any): Observable<any> {
    return this.apollo
    .use('project')
    .mutate({
      mutation: MODIFY_TASK_ASSIGNMENT,
      variables: {
        id: id,
        updateServiceTaskAssignmentInput,
        CreateTaskTimelineInput
      },
    })
    .pipe(map((result: any) => result.data.modifyTaskAssignment || []));
  }

  markAsCompletedAllServiceTaskAssignmentsForAnOrderService(orderServiceId: any): Observable<any> {
    return this.apollo
    .use('project')
    .mutate({
      mutation: MARK_AS_COMPLETED_ORDER_SERVICE,
      variables: {
        orderServiceId
      },
    })
    .pipe(map((result: any) => result.data.markAsCompletedAllServiceTaskAssignmentsForAnOrderService || []));
  }

  markAsCompletedAllServiceTaskAssignmentsForAnOrder(orderId: any): Observable<any> {
    return this.apollo
    .use('project')
    .mutate({
      mutation: MARK_AS_COMPLETED_ORDER,
      variables: {
        orderId
      },
    })
    .pipe(map((result: any) => result.data.markAsCompletedAllServiceTaskAssignmentsForAnOrder || []));
  }

  removeTaskTimeline(id: any): Observable<any> {
    return this.apollo
    .use('project')
    .mutate({
      mutation: REMOVE_TASK_TIMELINE,
      variables: {
        id
      },
    })
    .pipe(map((result: any) => result.data.removeTaskTimeline || []));
  }

  updateOrder(id: any, updateOrderInput: any): Observable<any> {
    return this.apollo
    .use('project')
    .mutate({
      mutation: UPDATE_ORDER,
      variables: {
        id,
        updateOrderInput
      },
    })
    .pipe(map((result: any) => result.data.updateOrder   || []));
  }

  getAllInProgressServiceTaskAssignmentsForAnOrder(
    orderId: any,
    ): Observable<any> {
      return this.apollo
        .use('project')
        .watchQuery<any>({
          query: GET_ALL_IN_PROGRESS_SERVICE_TASK_ASSIGNMENTS,
          variables: {
            orderId
          },
          fetchPolicy: 'network-only',
        })
        .valueChanges.pipe(
          map((result) => result.data?.getAllInProgressServiceTaskAssignmentsForAnOrder || [])
        );
    }

  orderServices(
    search: any,
    orderId: any,
    ): Observable<any> {
      return this.apollo
        .use('project')
        .watchQuery<any>({
          query: ORDER_SERVICES,
          variables: {
            search,
            orderId
          },
          fetchPolicy: 'network-only',
        })
        .valueChanges.pipe(
          map((result) => result.data?.orderServices || [])
        );
    }

  findAllOrdersWithPagination(
      input: any,
    ): Observable<any> {
      return this.apollo
        .use('project')
        .watchQuery<any>({
          query: FIND_ALL_ORDERS_PAGINATION,
          variables: {
            input
          },
          fetchPolicy: 'network-only',
        })
        .valueChanges.pipe(
          map((result) => result.data?.findAllOrdersWithPagination || [])
        );
    }
    findAllTaskAssignmentsWithPagination(
      input: any
    ): Observable<any> {
      return this.apollo
        .use('project')
        .watchQuery<any>({
          query: SERVICE_TASK_LIST_FOR_EMPLOYEE,
          variables: {
            input
          },
          fetchPolicy: 'network-only',
        })
        .valueChanges.pipe(
          map((result) => result.data?.findAllTaskAssignmentsWithPagination || [])
        );
    }
}
